import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 100px; /* stylelint-disable-line scales/space */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
